import React from 'react';
import sanitizeText from '../../utils/sanitizeText';
import Byline from '../blocks/Byline';
import Headline from '../blocks/Headline';
import Paragraph from '../blocks/Paragraph';
import Quote from '../blocks/Quote';
import SubHead from '../blocks/SubHead';
import Photo from '../Photo/Photo';
import { StoryContent } from '../Story';
function InsertAdElement({ adElement, children, }) {
    if (!adElement) {
        return React.createElement(React.Fragment, null, children);
    }
    const list = React.Children.toArray(children);
    switch (list.length) {
        case 0:
            return React.createElement(React.Fragment, null, list);
        case 1:
        case 2:
            return React.createElement(React.Fragment, null, list.concat(adElement));
        default:
            list.splice(2, 0, adElement);
            return React.createElement(React.Fragment, null, list);
    }
}
const BlocksContent = ({ blocks, adElement, lazyLoadImage, nextElement, }) => {
    return (React.createElement(StoryContent, null,
        nextElement,
        React.createElement(InsertAdElement, { adElement: adElement }, blocks.map((block, index) => {
            if ('paragraph' in block) {
                return (React.createElement(Paragraph, { key: index }, sanitizeText(block.paragraph.text)));
            }
            if ('pullQuote' in block) {
                return React.createElement(Quote, { key: index }, sanitizeText(block.pullQuote.text));
            }
            if ('headline' in block) {
                return React.createElement(Headline, { key: index }, sanitizeText(block.headline.text));
            }
            if ('byline' in block) {
                return React.createElement(Byline, { key: index }, sanitizeText(block.byline.text));
            }
            if ('subhead' in block) {
                return React.createElement(SubHead, { key: index }, sanitizeText(block.subhead.text));
            }
            if ('photo' in block) {
                if (!block.photo.dimensions) {
                    throw new Error('unexpected undefined photo.dimensions in block');
                }
                return (React.createElement(Photo, { ...block.photo.dimensions, caption: block.photo.caption && sanitizeText(block.photo.caption.text), credit: block.photo.credit && sanitizeText(block.photo.credit.text), key: index, lazyLoadImage: lazyLoadImage, url: block.photo.imageUrl }));
            }
            return null;
        }))));
};
export default BlocksContent;
//# sourceMappingURL=BlocksContent.js.map